import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';
import {INSTAGRAM_URL} from "@/utils/contants.js";

export const Footer = ({contestType = 'FOOTBALL'}) => {
    const {t} = useTranslation();
    const currentYear = new Date().getFullYear();

    const rulesLink = contestType ? `/rules?type=${contestType}` : '/rules';

    return (
        <footer
            className="mt-auto w-full pt-6 pb-12 flex flex-col items-center border-t border-gray-100/80 bg-linear-to-b from-white to-gray-50/50">

            {/* 1. NAVIGATION */}
            <nav className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 px-4 mb-4 max-w-sm mx-auto">
                <FooterLink to={rulesLink}>{t('footer.rules')}</FooterLink>
                <FooterLink to="https://gojokodo.com/privacy-policy">{t('footer.privacy')}</FooterLink>
                <FooterLink to="https://gojokodo.com/legal-notices">{t('footer.legal')}</FooterLink>
                <FooterLink to="/cgu">{t('footer.cgps')}</FooterLink>
            </nav>

            {/* 2. SIGNATURE COMPACTE (Logo + Insta + Copyright) */}
            <div
                className="flex flex-col items-center gap-2 opacity-30 hover:opacity-100 transition-opacity duration-500">

                {/* Ligne Logo + Instagram côte à côte */}
                <div className="flex items-center gap-3 grayscale hover:grayscale-0 transition-all duration-300">
                    <h1 className="text-[12px] font-black text-brand-dark mt-0 tracking-tight cursor-default">
                        GOJO<span className="text-[#FBBF24]">.</span>
                    </h1>

                    {/* Petit séparateur visuel */}
                    <span className="text-gray-300 text-[10px]">|</span>

                    {/* Icône Instagram SVG */}
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#E1306C] flex items-center"
                        aria-label="Instagram"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                        </svg>
                    </a>
                </div>

                {/* Ligne Copyright + Crédits */}
                <div className="text-center">
                    <p className="text-[9px] text-gray-500 font-medium">
                        © {currentYear} • GOJO KODO
                    </p>
                    <p className="text-[8px] text-gray-500 mt-1 font-medium">
                        Made with 🍔 & ⚽️
                    </p>
                </div>
            </div>
        </footer>
    );
};

// Composant Helper
const FooterLink = ({to, children}) => (
    <Link
        to={to}
        className="text-[10px] font-bold text-gray-400 uppercase tracking-widest hover:text-brand-dark transition-colors relative group whitespace-nowrap"
    >
        {children}
        <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-brand-dark transition-all group-hover:w-full"></span>
    </Link>
);